import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { AnnotationUtilsPanel } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/AnnotateUtilsPanel/AnnotationUtilsPanel";
import { CreateAnnotationButton } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/components/CreateAnnotationButton";
import { useAnnotationsToggle } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/hooks/useAnnotationsToggle";
import { useNoPreviewInVisualizer } from "~/hooks/useNoPreviewInVisualizer";
export const EditAnnotationsButton = /*#__PURE__*/ memo((param)=>{
    let { className } = param;
    const { showAnnotations, isAnnotationsEnabled, hideAnnotations } = useAnnotationsToggle();
    const { noPreviewInVisualizer } = useNoPreviewInVisualizer();
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: isAnnotationsEnabled ? /*#__PURE__*/ _jsx(AnnotationUtilsPanel, {
            onCloseClick: hideAnnotations
        }) : /*#__PURE__*/ _jsx(CreateAnnotationButton, {
            onClick: showAnnotations,
            shouldDisableAnnotations: noPreviewInVisualizer
        })
    });
});
EditAnnotationsButton.displayName = "EditAnnotationsButton";
